import React from 'react';
import { Container } from './ui/Container';
const links = ['Aviso Legal', 'Política de Privacidad', 'Política de Cookies', 'Términos y Condiciones', 'Contacto'];
export function Footer() {
  return <footer className="border-t border-mp-border bg-mp-black py-12 pb-24 md:pb-12" data-id="element-74" data-mp="32oniuyfytg6u">
      <Container data-id="element-75" data-mp="36p6aoshuym91">
        <div className="flex flex-col items-center gap-6 text-center md:flex-row md:items-center md:justify-between md:text-left" data-id="element-76" data-mp="36oo5h6d7wxoz">
          <div className="flex items-center gap-2" data-id="element-77" data-mp="3uftmhouw9w0v">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-mp-white text-[11px] font-heading font-bold text-mp-black" data-id="element-78" data-mp="3990ijjp5eap">
              MP
            </span>
            <span className="font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-79" data-mp="3qdf393nbcu92">Maestro en Pista</span>
          </div>

          <nav aria-label="Enlaces legales" data-id="element-80" data-mp="29yxc5agnxgkr">
            <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-mp-gray md:text-sm" data-id="element-81" data-mp="2a19tbleljmwr">
              {links.map(link => <li key={link} data-id="element-82" data-mp="3lalfndz543tf">
                  <a href="#" className="transition-colors duration-150 hover:text-mp-lime" data-id="element-83" data-mp="3l9sfwwylmeks">
                    {link}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        <p className="mx-auto mt-8 max-w-[650px] text-center text-xs leading-relaxed text-mp-gray/70 md:text-sm" data-id="element-84" data-mp="3q8mypywkg34w">
          Maestro en Pista es material educativo. Los resultados dependen de la aplicación, experiencia y
          circunstancias de cada profesional.
        </p>
        <p className="mx-auto mt-3 text-center text-xs text-mp-gray/50" data-id="element-85" data-mp="31upzjlpifqf">
          © Maestro en Pista 2026 — Todos los derechos reservados.
        </p>
      </Container>
    </footer>;
}